import { Component, OnInit } from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationService} from '../../../core/services/authentication.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-toastr-error',
  templateUrl: './toastr.component.html',
  styleUrls: ['./toastr.component.scss']
})
export class ToastrComponent implements OnInit {
error: any;
  constructor(private route: ActivatedRoute, private toastr: ToastrService,private auth: AuthenticationService) { 
    this.toastr.error(this.route.snapshot.paramMap.get('error'), 'Error');
    this.auth.goToDashboard('/');
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/toastr/toastr.component.ts